/* psa kit (page.hyt-bundle-offer-sa, page.wp-hyt-bundle-offer-sa).
   Buy = the hyt-bp / wmn-bp flow: clear the cart, add the offer line (variant + selling plan + Kaching bundle
   property when a deal is set + source tag) and the gift lines in one /cart/add.js, retry without the fiber
   sampler if that add fails, remove any gift the cart still prices above $0, then go to /checkout.
   Every [data-psa-open] opens the buy-box modal; [data-psa-facts] opens the facts modal. */
(function () {
  'use strict';
  /* every psa section renders this tag (so any one can stand alone); a repeated <script> runs again, so run once */
  if (window.__psaKit) return; window.__psaKit = true;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var SAMPLER = 54770520883572;

  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : '{}'
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  /* ---------- buy ---------- */
  function initBuy(hero) {
    var el = $('[data-psa-cfg]', hero); if (!el) return;
    var cfg; try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
    var busy = false;
    function buy(btn) {
      if (busy || !cfg.v) return;
      busy = true; btn.setAttribute('aria-busy', 'true');
      $$('[data-psa-err]', hero).forEach(function (e) { e.classList.remove('is-on'); });
      var props = {}; props[cfg.srcKey || '_psa_src'] = String(cfg.src || 'psa');
      var kid = '';
      if (cfg.deal) {
        if ((cfg.gifts || []).some(function (g) { return g.k; })) kid = Math.random().toString(36).slice(2, 8);
        var kb = { deal: cfg.deal, pp: cfg.pp, main: true, bid: cfg.bid }; if (kid) kb.id = kid;
        props.__kaching_bundles = JSON.stringify(kb);
      }
      var line = { id: cfg.v, quantity: cfg.q || 1, properties: props };
      if (cfg.plan) line.selling_plan = cfg.plan;
      var items = [line], giftIds = {};
      (cfg.gifts || []).forEach(function (g) {
        giftIds[g.v] = 1;
        if (g.k && cfg.deal) items.push({ id: g.v, quantity: 1, properties: { '__kaching_bundles': JSON.stringify({ id: kid, deal: cfg.deal, gift: g.k }) } });
        else if (g.s) items.push({ id: g.v, quantity: 1, properties: { _pc_gift: 'sticks' } });
        else items.push({ id: g.v, quantity: 1 });
      });
      if (cfg.checkout) window.__BBFIX_NO_AUTOOPEN = true;
      (cfg.clear ? post('/cart/clear.js') : Promise.resolve())
        .then(function () {
          return post('/cart/add.js', { items: items }).catch(function (e) {
            var rest = items.filter(function (it) { return it.id !== SAMPLER; });
            if (rest.length === items.length) throw e;
            return post('/cart/add.js', { items: rest });
          });
        })
        .then(function () {
          if (!Object.keys(giftIds).length) return;
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              var bad = (c.items || []).filter(function (it) { return giftIds[it.id] && it.final_line_price > 0; });
              return bad.reduce(function (p, it) { return p.then(function () { return post('/cart/change.js', { id: it.key, quantity: 0 }); }); }, Promise.resolve());
            }).catch(function () {});
        })
        .then(function () {
          if (cfg.checkout) { window.location.href = '/checkout'; return; }
          busy = false; btn.removeAttribute('aria-busy');
          if (window.__BBFIX_OPEN) window.__BBFIX_OPEN(); else window.location.href = '/cart';
        })
        .catch(function () {
          busy = false; btn.removeAttribute('aria-busy');
          var err = btn.parentNode && $('[data-psa-err]', btn.parentNode);
          if (err) err.classList.add('is-on');
        });
    }
    $$('[data-psa-buy]', hero).forEach(function (b) { b.addEventListener('click', function () { buy(b); }); });
  }

  /* ---------- modals ---------- */
  var lastFocus = null;
  function openMod(name) {
    var m = $('[data-psa-mod="' + name + '"]'); if (!m) return false;
    lastFocus = document.activeElement;
    m.classList.add('is-on'); document.documentElement.style.overflow = 'hidden';
    var x = $('[data-psa-close]', m); if (x) x.focus();
    return true;
  }
  function closeMods() {
    $$('.psa-mod.is-on').forEach(function (m) { m.classList.remove('is-on'); });
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-psa-open]');
    if (o) { if (openMod('buy')) e.preventDefault(); return; }
    var f = e.target.closest && e.target.closest('[data-psa-facts]');
    if (f) { openMod('facts'); return; }
    if (e.target.closest && e.target.closest('[data-psa-close]')) { closeMods(); return; }
    if (e.target.classList && e.target.classList.contains('psa-mod')) { closeMods(); return; }
    var j = e.target.closest && e.target.closest('[data-psa-jump]');
    if (j) {
      var h = j.getAttribute('href') || '';
      if (h.charAt(0) === '#') { var t = document.querySelector(h); if (t) { e.preventDefault(); scrollTo({ top: t.getBoundingClientRect().top + scrollY - 100, behavior: 'smooth' }); } }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMods(); });

  /* ---------- page parts ---------- */
  function ordinal(d) { var m = d % 100, n = d % 10; return d + ((m >= 11 && m <= 13) ? 'th' : n === 1 ? 'st' : n === 2 ? 'nd' : n === 3 ? 'rd' : 'th'); }
  function boot() {
    $$('[data-psa-hero]').forEach(initBuy);

    /* today's date (Pacific), as on hyt-bp / wmn-bp */
    try {
      var p = {}; new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', month: 'long', day: 'numeric' }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      $$('[data-psa-date]').forEach(function (e) { e.textContent = p.month + ' ' + ordinal(+p.day); });
    } catch (e) {}

    /* announcement: one item at a time on phones */
    $$('[data-psa-ann]').forEach(function (r) {
      var it = $$('.psa-ann__it', r), i = 0, t;
      if (it.length < 2) return;
      function go(d) { it[i].classList.remove('is-on'); i = (i + d + it.length) % it.length; it[i].classList.add('is-on'); }
      function auto() { clearInterval(t); t = setInterval(function () { go(1); }, 4000); }
      $$('[data-ann]', r).forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-ann')); auto(); }); });
      auto();
    });

    /* cart link opens the store drawer when it exists */
    $$('[data-psa-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) { if (window.__BBFIX_OPEN) { e.preventDefault(); window.__BBFIX_OPEN(); } });
    });

    /* gallery */
    $$('[data-psa-gal]').forEach(function (g) {
      var sl = $$('.psa-gal__slide', g), th = $$('.psa-gal__th', g), tr = $('.psa-gal__tr', g), i = 0;
      if (sl.length < 2) return;
      function show(n) {
        i = (n + sl.length) % sl.length;
        sl.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        if (th[i] && tr) tr.scrollTo({ left: th[i].offsetLeft - tr.offsetLeft - 40, behavior: 'smooth' });
      }
      th.forEach(function (t) { t.addEventListener('click', function () { show(+t.getAttribute('data-th')); }); });
      $$('[data-gal]', g).forEach(function (b) { b.addEventListener('click', function () { show(i + (+b.getAttribute('data-gal'))); }); });
      var main = $('.psa-gal__main', g), x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1)); x0 = null; });
    });

    /* gift tiles: tap shows what's included */
    $$('[data-psa-gifts]').forEach(function (box) {
      var out = $('[data-gift-out]', box);
      $$('[data-gift-d]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.getAttribute('data-gift-d'); if (!out || !d) return;
          var same = out.classList.contains('is-on') && out.getAttribute('data-for') === d;
          out.textContent = d; out.setAttribute('data-for', d); out.classList.toggle('is-on', !same);
        });
      });
    });

    /* guarantee "How it works" */
    $$('[data-psa-more]').forEach(function (b) {
      b.addEventListener('click', function () { var x = b.closest('.psa-mbg') && $('.psa-mbg__x', b.closest('.psa-mbg')); if (x) x.classList.toggle('is-on'); });
    });

    /* facts tabs */
    $$('.psa-facts').forEach(function (m) {
      $$('[data-ft]', m).forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-ft');
          $$('[data-ft]', m).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          $$('[data-fp]', m).forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-fp') === k); });
        });
      });
    });

    /* creator videos: tap to play with sound, one at a time */
    var ugc = $$('[data-psa-ugc]');
    ugc.forEach(function (c) {
      var v = $('video', c), b = $('.psa-ugc__pl', c);
      if (!v || !b) return;
      function stopOthers() { ugc.forEach(function (o) { if (o !== c) { var ov = $('video', o); if (ov) ov.pause(); o.classList.remove('is-play'); } }); }
      b.addEventListener('click', function () { stopOthers(); v.muted = false; v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); c.classList.add('is-play'); });
      v.addEventListener('click', function () { if (!v.paused) { v.pause(); c.classList.remove('is-play'); } });
      v.addEventListener('ended', function () { c.classList.remove('is-play'); });
    });

    /* silent loops play only on screen */
    var loops = $$('[data-psa-vid]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
      }, { rootMargin: '200px 0px' });
      loops.forEach(function (v) { io.observe(v); });
    }

    /* footer columns: accordions on phones only */
    function cols() { var ph = window.innerWidth < 768; $$('[data-psa-fcol]').forEach(function (d) { if (ph) d.removeAttribute('open'); else d.setAttribute('open', ''); }); }
    cols();

    /* reviews widget: init if the app script loaded before the element existed */
    setTimeout(function () {
      $$('[data-oke-widget]').forEach(function (w) { if (!w.children.length && window.okeWidgetApi && window.okeWidgetApi.initWidget) { try { window.okeWidgetApi.initWidget(w); } catch (e) {} } });
    }, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
